import React from 'react'
import FormCheckbox from 'components/forms/bases/FormCheckbox'
import { updateObject } from 'helpers/objectHelpers'
import MainHeader from 'components/headers/MainHeader'
import FormTextAlign from 'components/forms/FormTextAlign'
import FormInputNumber from 'components/forms/FormInputNumber'

const wrapperStyle = {
  padding: 15,
  border: '1px solid #e8e8e8',
  borderRadius: 5,
  marginBottom: 10,
}

const CardSettings = ({
  value,
  value: {
    isZoomWhenHovered,
    headerAlign,
    headerSize,
    descriptionAlign,
    descriptionSize,
    fluid,
  },
  onChange,
}) => {
  const handleChange = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  const array = [
    { label: 'center', value: 'center' },
    { label: 'left', value: 'left' },
    { label: 'right', value: 'right' },
  ];
  return (
    <div style={{ paddingTop: 5 }}>
      <div style={wrapperStyle}>
        <MainHeader small>Card</MainHeader>
        <FormCheckbox
          label="Full Width"
          value={fluid}
          onChange={(val) => handleChange(val, 'fluid')}
        />
      </div>

      <div style={wrapperStyle}>
        <MainHeader small>Image</MainHeader>
        <FormCheckbox
          label="is zoom when hovered"
          value={isZoomWhenHovered}
          onChange={(val) => handleChange(val, 'isZoomWhenHovered')}
        />
      </div>

      <div style={wrapperStyle}>
        <MainHeader small>Header</MainHeader>
        <FormTextAlign
          label="Header Align"
          value={headerAlign}
          onChange={(val) => handleChange(val, 'headerAlign')}
          options={array}
        />
        <FormInputNumber
          label="Font Size"
          value={headerSize}
          onChange={(val) => handleChange(val, 'headerSize')}
        />
      </div>

      <div style={wrapperStyle}>
        <MainHeader small>Description</MainHeader>
        <FormTextAlign
          label="Description Align"
          value={descriptionAlign}
          onChange={(val) => handleChange(val, 'descriptionAlign')}
          options={array}
        />
        <FormInputNumber
          label="Description Size"
          value={descriptionSize}
          onChange={(val) => handleChange(val, 'descriptionSize')}
        />
      </div>
    </div>
  )
}

CardSettings.propTypes = {}
CardSettings.defaultProps = {}

export default CardSettings



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/card/CardSettings.js